import {
  createLoader,
  createSerializer,
  parseAsString,
  parseAsStringLiteral,
} from "nuqs/server";

const logoutReasons = ["expired", "required"] as const;

const logoutSearchParams = {
  logout: parseAsStringLiteral(logoutReasons)
    .withDefault("expired")
    .withOptions({ clearOnDefault: false }),
  redirectPath: parseAsString,
};

/**
 * logout route の query から理由と内部復帰先候補を読み込みます。
 * `logout` の欠落・未知値は `expired`、`redirectPath` の欠落は `null` に正規化します。
 */
export const loadLogoutSearchParams = createLoader(logoutSearchParams);

/**
 * logout route の query を共通 contract に従って生成します。
 * `expired` も明示し、`null` の復帰先は省略して、文字列値は一度だけ URL encode します。
 */
export const serializeLogoutSearchParams = createSerializer(logoutSearchParams);
